/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Flow_NoteInputs */

const en_services_flow_note = /** @type {(inputs: Services_Flow_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready for your team to review.`)
};

const lv_services_flow_note = /** @type {(inputs: Services_Flow_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatavs Jūsu komandai pārskatīšanai.`)
};

/**
* | output |
* | --- |
* | "Ready for your team to review." |
*
* @param {Services_Flow_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_flow_note = /** @type {((inputs?: Services_Flow_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Flow_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_flow_note(inputs)
	return en_services_flow_note(inputs)
});